import { FC } from 'react';
import {
  Typography,
  Spacing,
  StyledDiv,
  TitleText,
  List,
} from '@taleemabad/dsm/components';
import {
  ISchoolClassInfo,
  IStudentSubjectAnswerAnalysis,
} from '@taleemabad/db';

enum InsightCategory {
  Grammar = 'Grammar Mistakes',
  Spelling = 'Spelling Mistakes',
  SentenceStructure = 'Sentence Structure Mistakes',
}

interface ReportCardClassInsightsProps {
  classDetails: ISchoolClassInfo;
  assessmentName: string;
  insights: IStudentSubjectAnswerAnalysis[];
  onSelectInsight: (insight: InsightCategory) => void;
}

const TRAILING_ICON = {
  direction: 'trailing',
  source: 'keyboard_arrow_right',
  name: 'keyboard_arrow_right',
  type: 'icon',
} as const;

const INSIGHT_CATEGORIES = Object.values(InsightCategory);

export const ReportCardClassInsights: FC<ReportCardClassInsightsProps> = ({
  classDetails,
  assessmentName,
  insights,
  onSelectInsight,
}) => {
  return (
    <>
      <Spacing marginTop="xl" marginBottom="md">
        <Typography variant="textTitleLarge" fullWidth>
          {assessmentName} Results
        </Typography>
      </Spacing>

      <Spacing marginBottom="xl">
        <TitleText
          leftText={`${classDetails.gradeLabel} - ${classDetails.section}`}
          rightText={classDetails.subjectLabel ?? ''}
          seperatorIconName="circle"
        />
      </Spacing>

      {insights.length === 0 ? (
        <StyledDiv
          justifyContent="center"
          alignItem="center"
          height="calc(100vh - 300px)"
          textAlign="center"
        >
          <Typography variant="textBodyLargeOnSurfaceVariant">
            No insights available for this assessment.
          </Typography>
        </StyledDiv>
      ) : (
        <StyledDiv flexDirection="column" gap={16}>
          <Spacing marginBottom="xl">
            <Typography variant="textBodyMedium">
              Select an area to see insights.
            </Typography>
          </Spacing>
          {INSIGHT_CATEGORIES.map((category) => (
            <List
              key={category}
              alignment="center"
              heading={category}
              trailingIcon={TRAILING_ICON}
              onClick={() => onSelectInsight(category)}
            />
          ))}
        </StyledDiv>
      )}
    </>
  );
};
